import { Component, Inject } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { RouterOutlet, Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { slideInAnimation } from '../app/animations';
import { PageScrollService } from 'ngx-page-scroll-core';
import { GeneralService } from './services/general/general.service';
import { environment } from 'src/environments/environment';
import { keysApp } from './resources/keys.resources';
import { UtilsResource } from './resources/UtilsResource.resource';
import { ActionsEventsService } from './services/actions-events/actions-events.service';
import { Observable } from 'rxjs';
import { UniversalService } from './services/universal/universal.service';
import { StoreServiceLibrary } from './services/store/store.service';
import { GeneralUtilService } from './services/general-util/generalUtil.service';
import { GetJWTTokenService } from './services/getJWTToken/get-jwttoken.service';
import { SecurityModel } from './models/security.model';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    slideInAnimation
    // animation triggers go here
  ]
})
export class AppComponent {
  title = 'website';

  idApplication;

  jwtTokenAuthLoaded = false;
  path: string;

  universalJwtUrl;
  universalJwtUN;
  universalJwtPW;
  useJwtTokenUniversal;

  constructor(
    private translate: TranslateService,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
    private store: StoreServiceLibrary,
    private generalService: GeneralService,
    private _generalUtilService: GeneralUtilService,
    private actionEventService: ActionsEventsService,
    private universalService: UniversalService,
    private jwtService: GetJWTTokenService,
    private route: ActivatedRoute, location: Location, private router: Router
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.detectedLangNavigator();

    router.events.subscribe((val) => {
      this.path = location.path();
      this.path = this.path.substring(1);
    });
  }

  ngOnInit(): void {
    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: '.theEnd',
    });
    this.initializeApp();
  }

  prepareRoute() {
    try {
      const firstChild = this.router.routerState.root.firstChild;
      return firstChild && firstChild.snapshot && firstChild.snapshot.data && firstChild.snapshot.data['animation'];
    } catch (e) {
      return null;
    }
  }

  initializeApp() {
    this.idApplication = environment.idApplication;
    this.store.setIdAplication(this.idApplication);
    StoreServiceLibrary.application = String(this.idApplication);
    // this.asignarLenguajePorApp();

    let objConfigSecurity = this.store.getItemFromStorage(keysApp.SECURITY_LAST_OBJ);
    if (typeof objConfigSecurity != 'undefined') {
      if (Object.keys(objConfigSecurity).length > 0) {
        this._generalUtilService.setSecurityObject(objConfigSecurity);
        this.store.setItemInStorage(keysApp.SECURITY_LAST_OBJ, objConfigSecurity);
        UtilsResource.NSMarkLog('LOAD AFTER SECURITY OBJECT');
        UtilsResource.NSMarkLog('SEND EVENT UNIVERSAL LOAD');
        this.store.setIsUniversalLoad(true);
        this.actionEventService.universalLoad(true);
        this.getConfigUser().subscribe((resp) => {
          this.getParametersUniversal();
        });
      } else {
        this.getConfigUser().subscribe((resp) => {
          let universalPropertiesList = this.store.getAllUniversalProperties();
          if (universalPropertiesList?.length > 0) {
            UtilsResource.NSMarkLog('SET EVENT UNIVERSAL LISTENER*******')
            this.store.setIsUniversalLoad(true);
            this.actionEventService.universalLoad(true);
            this.getParametersUniversal();
          } else {
            this.getParametersUniversal();
          }
          UtilsResource.ShowLog('Universal LOAD FINISH ');
        }, (err) => {
          UtilsResource.ShowLog('ERROR, EN EL GET CONFIG USER', err);
        });
      }
    } else {
      this.getConfigUser().subscribe((resp) => {
        let universalPropertiesList = this.store.getAllUniversalProperties();
        if (universalPropertiesList?.length > 0) {
          UtilsResource.NSMarkLog('SET EVENT UNIVERSAL LISTENER*******')
          this.store.setIsUniversalLoad(true);
          this.actionEventService.universalLoad(true);
          this.getParametersUniversal();
        } else {
          this.getParametersUniversal();
        }
        UtilsResource.ShowLog('Universal LOAD FINISH ');
      }, (err) => {
        UtilsResource.ShowLog('ERROR, EN EL GET CONFIG USER', err);
      });
    }
  }

  getConfigUser() {
    let urlConfig = environment.configChannel[this.idApplication].CONFIG_USER_GET_JWTTOKEN_URL || '';
    let urlJwtConfig = environment.configChannel[this.idApplication].UNIVERSAL_GET_JWTTOKEN_URL_COUNTRY || '';
    const fpUniversaljwt = environment.configChannel[this.idApplication].fpUniversaljwt || null;
    let reqPass = environment.configChannel[this.idApplication].reqPass;
    let resPass = environment.configChannel[this.idApplication].resPass;
    let localDate = atob(environment.configChannel[this.idApplication].timeZoneDefault || '');
    let languajeTimeDefault = atob(environment.configChannel[this.idApplication].languajeTimeDefault || '');

    // if (this.contGetConfig == 0) {
    //   let date = new Date();
    //   this._generalUtilService.setLocalDate(date);
    // } else {
    let date = new Date().toLocaleString(languajeTimeDefault, {
      timeZone: localDate
    });
    let dateTmp = new Date(date);
    this._generalUtilService.setLocalDate(dateTmp);
    // }
    let useJwtTokenUniversal = this.generalService.getJwtUseFilter('useJwtTokenUniversal');
    let universalJwtUN = environment.configChannel[this.idApplication].UNIVERSAL_GET_JWTTOKEN_UN || '';
    let universalJwtPW = environment.configChannel[this.idApplication].UNIVERSAL_GET_JWTTOKEN_PW || '';
    return new Observable((observer) => {
      this.universalService.getConfigGlobalUser(
        useJwtTokenUniversal,
        true,
        urlConfig,
        urlJwtConfig,
        atob(universalJwtUN),
        atob(universalJwtPW),
        fpUniversaljwt,
        reqPass,
        resPass
      ).subscribe((data: any) => {
        const security = new SecurityModel();
        security.ip = data?.ip;
        security.host = 'localhost';
        security.cookie = 'cookie';
        security.userAgent = StoreServiceLibrary.isWebLogin ? 'bitacora' : 'Application';
        // security.deviceFingerPrint = this.platform.is('ios') ? 'device_ios' : 'device_android';
        security.deviceFingerPrint = 'device_android';
        this._generalUtilService.setSecurityObject(security);
        this.store.setItemInStorage(keysApp.SECURITY_LAST_OBJ, security);

        UtilsResource.NSMarkLog('getConfigGlobalUser - ', security);

        let isValidLocalDate = this.generalService.validateLocalDate(data?.timezone, data?.date);
        if (isValidLocalDate) {
          UtilsResource.NSMarkLog('SET LOAD FLAG *******');
          // this._eventsService.setLoadBiometric();
          observer.next();
          observer.complete();
        } else {
          // this.loadUniversalZoneDefault();
        }
      },
        (err) => {
          observer.error();
          observer.complete();
        }
      );
    });
  }

  getParametersUniversal() {
    this.store.setIsUniversalLoad(false);
    const secretKey = atob(environment.idSK);

    this.useJwtTokenUniversal = this.generalService.getJwtUseFilter('useJwtTokenUniversal');
    this.universalJwtUrl = environment.configChannel[this.idApplication].UNIVERSAL_GET_JWTTOKEN_URL || '';
    this.universalJwtUN = environment.configChannel[this.idApplication].UNIVERSAL_GET_JWTTOKEN_UN || '';
    this.universalJwtPW = environment.configChannel[this.idApplication].UNIVERSAL_GET_JWTTOKEN_PW || '';

    const fpuniversal = environment.configChannel[this.idApplication].fpUniversal || null;
    const fpUniversaljwt = environment.configChannel[this.idApplication].fpUniversaljwt || null;
    const URL = environment.configChannel[this.idApplication].universalUrlBase;

    const reqPass = environment.configChannel[this.idApplication].reqPass;
    const resPass = environment.configChannel[this.idApplication].resPass;

    this.universalService.getAllPropertiesByApplicationidVSDecrypt(
      URL, btoa(this.idApplication + ''), secretKey,
      this.universalJwtUrl,
      atob(this.universalJwtUN),
      atob(this.universalJwtPW),
      this.useJwtTokenUniversal,
      fpuniversal,
      fpUniversaljwt,
      reqPass,
      resPass
    ).subscribe(
      (res) => {
        this.store.setUniversalProperties(res.propertyDtoList);
        this.store.setIdAplication(this.idApplication);
        // this.store.setIsUniversalLoad(true);
        // this.actionEventService.universalLoad(true);
        let useJwtTokenAuth = this.generalService.getJwtUseFilter('useJwtTokenAuth');
        this.jwtService.setJwtTokenAuth(useJwtTokenAuth).subscribe((res) => {
          this.jwtTokenAuthLoaded = true;
          this.finishJwts();
        }, (err) => {
          UtilsResource.NSMarkLogError("setJwtTokenAuth::", err);
          this.jwtTokenAuthLoaded = false;
          this.finishJwts();
        });
      },
      (error) => {
        UtilsResource.NSMarkLogError("getAllPropertiesByApplicationidVSDecrypt error::", error);
      }
    );
  }

  finishJwts() {
    if (this.jwtTokenAuthLoaded) {
      this.store.setIsUniversalLoad(true);
      this.actionEventService.universalLoad(true);

      this.getCountries();
    }
  }

  detectedLangNavigator() {
    // Detectar el idioma del navegador
    const browserLang = navigator.language.split('-')[0]; // Ejemplo: 'en' de 'en-US'
    const supportedLangs = ['en', 'es']; // Idiomas soportados

    // Configurar el idioma inicial
    const defaultLang = supportedLangs.includes(browserLang) ? browserLang : 'en';
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);
  }

  getCountries() {
    const fpUniversaljwt = environment.configChannel[environment.idApplication].fpUniversaljwt || null;
    let reqPass = environment.configChannel[environment.idApplication].reqPass;
    let resPass = environment.configChannel[environment.idApplication].resPass;
    // this.countries = (await this._universal.getCountries(null, this.universalJwtUrl, atob(this.universalJwtUN), atob(this.universalJwtPW), this.useJwtTokenUniversal, fpUniversaljwt, '', reqPass, resPass).toPromise()).countryDtoList;
    this.universalService.getCountries(null, this.universalJwtUrl, atob(this.universalJwtUN), atob(this.universalJwtPW), this.useJwtTokenUniversal, fpUniversaljwt, '', reqPass, resPass)
      .subscribe(
        res => {
          let countries = res.countryDtoList;
          this.store.setItemInStorage('COUNTRIES', countries);
          this.actionEventService.completeCallCountries(res);
        },
        (err) => {
          UtilsResource.ShowLog('NO SE PUDIERON CONSULTAR LAS PAISES');
        }
      );
  }
}
